export default __webpack_public_path__ + "static/media/Toilet - Grey.254d304e.svg";